import React from "react";
import CustomCursor from "../../Global/Cursor";
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header1";
import PageHeader from "../MenTeam/PageHeader";
import TeamOne from "../MenTeam/TeamOne";
import CtaTwo from "../../Global/Cta";
import Footer from "../../Global/Footer1";
import GoToTop from "../../Global/GoToTop";
const Main = () => {

    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader />
            <TeamOne />
            <CtaTwo />
            <Footer />
            <GoToTop />
        </>
    )
}
export default Main;